/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsShapeLinkFill: {
  name: 'shape-link-fill';
  data: string;
} = {
  name: 'shape-link-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1A.5.5 0 0 1 1 .5h6a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H1A.5.5 0 0 1 .5 7V1Zm7 8.207L9.207 7.5H15a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5H9a.5.5 0 0 0-.5.5v5.793L6.793 8.5H1a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V9.207ZM9 8.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5H9Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
